import React, { useState } from "react";

export type Tab = [key: string, label: string, badge?: number, tone?: string, title?: string];

export function useSavedTab(storeKey: string, fallback: string, keys: string[]) {
  const [v, setV] = useState<string>(() => localStorage.getItem(storeKey) || fallback);
  const set = (k: string) => { setV(k); localStorage.setItem(storeKey, k); };
  return [keys.includes(v) ? v : fallback, set] as const;
}

export function TabBar({ tabs, value, onChange, testId, prefix }: { tabs: Tab[]; value: string; onChange: (k: string) => void; testId: string; prefix: string }) {
  return (
    <div className="sticky top-[53px] z-30 -mx-1 flex overflow-x-auto bg-[#F9F8F5]/95 px-1 py-2 backdrop-blur lg:top-0" data-testid={testId}>
      <div className="mx-auto inline-flex min-w-max gap-1 rounded-xl border border-[#E2E8F0] bg-white p-1 shadow-sm" role="tablist">
        {tabs.map(([k, label, n, tone, title]) => (
          <button key={k} role="tab" aria-selected={value === k} onClick={() => onChange(k)} data-testid={`${prefix}-${k || "open"}`} title={title}
            className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors ${value === k ? "bg-[#1B365D] text-white" : "text-[#475569] hover:bg-[#F1F5F9]"}`}>
            {label}{n ? <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${value === k ? "bg-white/20 text-white" : tone || "bg-[#F1F5F9] text-[#475569]"}`} data-testid={`${prefix}-badge-${k || "open"}`}>{n}</span> : null}
          </button>
        ))}
      </div>
    </div>
  );
}
